import React from 'react';
import { AlertTriangle } from 'lucide-react';

// A4: aviso en la pantalla de automatizaciones si Atención al Cliente no corre a diario.
export const AvisoFrecuenciaAtencion = ({ autos = [] }) => {
  const a = autos.find((x) => x.id === 'atencion-freshdesk');
  if (!a || (a.frecuencia === 'diaria' && a.activa)) return null;
  const actual = a.activa ? `está en frecuencia «${a.frecuencia}»` : 'está desactivada';
  return (
    <div className="mb-4 flex items-start gap-2 rounded-lg border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-900" data-testid="aviso-frecuencia-atencion">
      <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-amber-600" />
      <span>
        La automatización <b>{a.nombre || 'Atención al Cliente — Tickets de Freshdesk'}</b> {actual}. Trae los tickets actualizados en
        los últimos 7 días: para que un ticket que se cierra en Freshdesk aparezca cerrado al día siguiente, configurala en <b>Diaria 03:00</b>.
      </span>
    </div>
  );
};

export default AvisoFrecuenciaAtencion;
